import {
  API_URL,
  AuthService,
  ErrorInterceptor,
  LoggerService,
  MonitoringService,
  provideTranslations,
  SharedConstantService,
  WithCredentialsInterceptor,
} from '@agroone-front/shared'
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http'
import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core'
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async'
import { provideRouter, TitleStrategy } from '@angular/router'
import { environment } from '@front-app-environments/environment'
import { TranslateService } from '@ngx-translate/core'
import { firstValueFrom } from 'rxjs'
import { appRoutes } from './app.routes'
import { UserService } from './features/user-preferences/user.service'
import { MasterdataTitleStrategy } from './masterdata-title.strategy'
import { TranslationsLoader } from './translations.loader'

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(appRoutes),
    {
      provide: TitleStrategy,
      useClass: MasterdataTitleStrategy,
    },
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    provideAnimationsAsync(),
    LoggerService,
    MonitoringService,
    { provide: API_URL, useValue: environment.apiUrl },
    provideAppInitializer(async () => {
      const authService = inject(AuthService)
      const loggerService = inject(LoggerService)
      const userService = inject(UserService)
      const constantService = inject(SharedConstantService)
      loggerService.init(environment.logLevel, environment.serverLogLevel)
      authService.init(environment.cognitoDomain, environment.cognitoClientId, environment.apiUrl)
      try {
        const user = await firstValueFrom(userService.getUser())
        await firstValueFrom(constantService.load(user))
      } catch (error) {
        loggerService.error('Masterdata app initialisation failed', JSON.stringify(error))
      }
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: WithCredentialsInterceptor,
      multi: true,
    },
    provideTranslations(TranslationsLoader, 'en-us'),
    provideAppInitializer(() => {
      const translateService = inject(TranslateService)
      return translateService.use('en-us')
    }),
  ],
}
